import React from 'react';
import { Box, Container, Grid, Card, CardContent, Typography } from '@mui/material';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import WifiTetheringIcon from '@mui/icons-material/WifiTethering';

const VibeSection = () => {
  const cards = [
    {
      title: 'Hızlı Kurulum',
      description: 'Altyapı Beklemek Yok, Fişe Takıp Bağlanmak Var!',
      icon: <FlashOnIcon sx={{ fontSize: 60, color: 'secondary.main' }} />,
    },
    {
      title: 'Özgür İnternet',
      description: 'Kablo Derdi Bitti, İnternet Özgürlüğü Evinize Geldi.',
      icon: <WifiTetheringIcon sx={{ fontSize: 60, color: 'secondary.main' }} />,
    }
  ];

  return (
    <Box sx={{ py: 10, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h2"
          textAlign="center"
          color="primary.main"
          gutterBottom
          sx={{ mb: 6, fontWeight: 'bold' }}
        >
          Neden Fiber Telekom?
        </Typography>

        <Grid container spacing={4}>
          {cards.map((card, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  p: 3,
                  transition: 'transform 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                  }
                }}
              >
                <Box sx={{ mb: 2 }}>
                  {card.icon}
                </Box>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    {card.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
                    {card.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default VibeSection;
